"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    GT_HEX: '0x3e',
    LT_HEX: '0x3c',
    GTE_HEX: '0x3e3d',
    LTE_HEX: '0x3c3d',
    EQ_HEX: '0x3d3d',
    NULL_ADDRESS: '0x0000000000000000000000000000000000000000',
    EXECUTEDLOG: '0x3e504bb8b225ad41f613b0c3c4205cdd752d1615b4d77cd1773417282fcfb5d9',
    ABORTEDLOG: '0xc008bc849b42227c61d5063a1313ce509a6e99211bfd59e827e417be6c65c81b',
    NEWREQUESTLOG: '0x2749295aa7ffdbd4d16719dc03d592cd081eebd9bb790ceedce201a40675fc03',
    BUCKET_SIZE: {
        block: 240,
        timestamp: 3600
    }
};
//# sourceMappingURL=Constants.js.map